import classNames from "classnames";
import classes from "./RadioButton.module.css";
import useTranslation from "next-translate/useTranslation";

type Props = {
  id?: string;
  name: string;
  value: string;
  label: string;
  onChangeHandler?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  description?: string;
  error?: boolean;
  className?: string;
  handleCategoryChange?: (category: string) => void;
  readonly?: boolean;
  disabled?: boolean;
};

const RadioButton = ({
  id,
  name,
  value,
  label,
  onChangeHandler,
  checked,
  description,
  error,
  className,
  handleCategoryChange,
  readonly,
  disabled,
}: Props) => {
  const changeHandler =
    onChangeHandler &&
    ((event: React.ChangeEvent<HTMLInputElement>) => {
      onChangeHandler(event);
      if (handleCategoryChange) {
        handleCategoryChange(value);
      }
    });
  return (
    <div
      className={classNames(
        classes.radioButton,
        { [classes.error]: error, [classes.disabled]: disabled },
        className
      )}
    >
      <input
        type="radio"
        name={name}
        value={value}
        onChange={changeHandler}
        checked={checked}
        readOnly={readonly}
        disabled={disabled}
      />
      <div>
        <label>{label}</label>
        {description && <p>{description}</p>}
      </div>
    </div>
  );
};

export default RadioButton;
